var datePicker = {
  options: {
  },

  selectors: {
    accomodations_input_filter_date_from: '#js-accomodations-input-filter-date-from',
    accomodations_input_filter_date_to: '#js-accomodations-input-filter-date-to',

    accomodation_reservation_input_date_from: '.js-accomodation-reservation-input-date-from',
    accomodation_reservation_input_date_to: '.js-accomodation-reservation-input-date-to',
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    //Filter in archive-accomodation.php
    jQuery(self.selectors.accomodations_input_filter_date_from).daterangepicker({
      minDate: moment(), //now
      autoApply: true,
      autoUpdateInput: false,
      locale: {
        format: 'DD.MM.YYYY',
        daysOfWeek: sikmoVars.translation.list_days_of_week,
      }
    });

    //input Apply event
    jQuery(self.selectors.accomodations_input_filter_date_from).on('apply.daterangepicker', function (ev, picker) {
      jQuery(self.selectors.accomodations_input_filter_date_from).val(picker.startDate.format('DD.MM.YYYY'));
      jQuery(self.selectors.accomodations_input_filter_date_to).val(picker.endDate.format('DD.MM.YYYY'));

      jQuery(self.selectors.accomodations_input_filter_date_from).trigger("input"); //trigger input event
      jQuery(self.selectors.accomodations_input_filter_date_to).trigger("input"); //trigger input event
    });

    //input Focus event
    jQuery(self.selectors.accomodations_input_filter_date_to).on("focus", function () {
      jQuery(self.selectors.accomodations_input_filter_date_from).trigger("click");
    });

    jQuery(self.selectors.accomodations_input_filter_date_to).on("input", function () {
      //update endDate in calendar when date_to is changed
      jQuery(self.selectors.accomodations_input_filter_date_from).data('daterangepicker').setEndDate(jQuery(this).val());
    });

    //Reservation form in single-accomodation.php
    jQuery(self.selectors.accomodation_reservation_input_date_from).daterangepicker({
      minDate: moment(), //now
      autoApply: true,
      autoUpdateInput: false,
      isInvalidDate: function (object_moment) {
        const formated_date = parseInt(object_moment.format("YYYYMMDD"));
        if (accomodation_reserved_dates.includes(formated_date)) {
          return true; //disable this date pick
        }
        return false;
      },
      isCustomDate: function (object_moment) {
        const formated_date = parseInt(object_moment.format("YYYYMMDD"));

        let classes = [];

        classes.push("js-the-date-is-" + formated_date); //add the current date into class

        if (formated_date in accomodation_next_prices_per_day) {
          classes.push("btkc-different-price"); //add this css class to the date
        }

        if (accomodation_in_progress_dates.includes(formated_date)) {
          classes.push("btkc-in-progress"); //add this css class to the date
        }

        return classes.join(" ");
      },
      locale: {
        format: 'DD.MM.YYYY',
        daysOfWeek: sikmoVars.translation.list_days_of_week,
      }
    });

    jQuery(self.selectors.accomodation_reservation_input_date_from).on('apply.daterangepicker', function (ev, picker) {
      jQuery(self.selectors.accomodation_reservation_input_date_from).val(picker.startDate.format('DD.MM.YYYY'));
      jQuery(self.selectors.accomodation_reservation_input_date_to).val(picker.endDate.format('DD.MM.YYYY'));

      jQuery(self.selectors.accomodation_reservation_input_date_from).trigger("input"); //trigger input event
      jQuery(self.selectors.accomodation_reservation_input_date_to).trigger("input"); //trigger input event
    });

    jQuery(self.selectors.accomodation_reservation_input_date_to).on("focus", function () {
      jQuery(self.selectors.accomodation_reservation_input_date_from).trigger("click");
    });

    jQuery(self.selectors.accomodation_reservation_input_date_to).on("input", function () {
      //update endDate in calendar when date_to is changed
      jQuery(self.selectors.accomodation_reservation_input_date_from).data('daterangepicker').setEndDate(jQuery(this).val());
    });

    // Add tooltips dynamically when the calendar is displayed
    jQuery(self.selectors.accomodation_reservation_input_date_from).on('showCalendar.daterangepicker', function (event, picker) {

      // Process the left calendar
      const leftCalendar = picker.container.find('.drp-calendar.left'); // Left calendar
      self.createTooltipsInCalendar(leftCalendar);

      // Process the right calendar
      const rightCalendar = picker.container.find('.drp-calendar.right'); // Right calendar
      self.createTooltipsInCalendar(rightCalendar);
    });

    // Add custom HTML under the calendar
    jQuery(self.selectors.accomodation_reservation_input_date_from).on('show.daterangepicker', function (event, picker) {
      // Check if the legend already exists to avoid duplicates
      if (!jQuery('.accomodation-datebox-legend').length) {
        const customLegend = `
          <div class="accomodation-datebox-legend">
            <ul>
              <li><span class="legend white"></span> <span>` + sikmoVars.translation.reservation.available + `</span></li>
              <li><span class="legend yellow"></span> <span>` + sikmoVars.translation.reservation.available_maybe + `</span></li>
              <li><span class="legend dot"></span> <span>` + sikmoVars.translation.reservation.different_price + `</span></li>
            </ul>
          </div>
        `;
        // Insert the legend into the DOM under the calendar
        jQuery(picker.container).append(customLegend);
      }
    });
  },

  //Universal date range picker
  createDateRangePicker: function (jquery_input_date_from, jquery_input_date_to) {
    jquery_input_date_from.daterangepicker({
      minDate: moment(), //now
      autoApply: true,
      autoUpdateInput: false,
      locale: {
        format: 'DD.MM.YYYY',
        daysOfWeek: sikmoVars.translation.list_days_of_week,
      }
    });

    jquery_input_date_from.on('apply.daterangepicker', function (ev, picker) {
      const this_jquery_date_from = jQuery(this);
      const this_jquery_date_to = jQuery(this).parent().parent().find(".js-type-daterange-to"); //near .js-type-daterange-to

      this_jquery_date_from.val(picker.startDate.format('DD.MM.YYYY'));
      this_jquery_date_to.val(picker.endDate.format('DD.MM.YYYY'));

      this_jquery_date_from.trigger("input"); //trigger input event
      this_jquery_date_to.trigger("input"); //trigger input event
    });

    jquery_input_date_to.on("focus", function () {
      jQuery(this).parent().parent().find(".js-type-daterange-from").trigger("click"); //near .js-type-daterange-from
    });
  },

  createTooltipsInCalendar: function (calendar) {
    calendar.find('td.available').each(function () {
      const fullClass = jQuery(this).attr('class'); // Get the full class attribute
      const dateValue = fullClass.match(/js-the-date-is-(\d+)/); // Extract the number
    
      if (dateValue) {
        let price = 0;

        if (typeof accomodation_next_prices_per_day[dateValue[1]] !== "undefined") {
          price = accomodation_next_prices_per_day[dateValue[1]] + " " + accomodation_currency;
        } else {
          price = accomodation_default_price_per_day + " " + accomodation_currency;
        }

        // Apply custom tooltip logic
        jQuery(this).addClass('custom-tooltip'); // Add a custom class for styling
        jQuery(this).attr('data-tooltip', price); // Add tooltip text
      }
    });
  }
}

export { datePicker };